/**
 * Styled Components - Created by cazarez on 05/05/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import Icon from 'antd/lib/icon'
import { BLUE, WHITE, GRAY_DARK, BLACK_SHADOW, GREEN, BLACK } from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'

interface DivProps {
  show?: boolean
}

interface StyledProps {
  small?: boolean
}

export const Container = styled.div`
  padding: 40px 32px;
  background-color: ${WHITE};
  position: relative;
  @media (max-width: 698px) {
    padding-top: 46px;
  }
  @media (max-width: 480px) {
    padding: 20px 10px 40px 10px;
    padding-top: 46px;
  }
`
export const Content = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`
export const CheckoutTitle = styled.div`
  height: 27px;
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  margin-bottom: 40px;
  @media (max-width: 698px) {
    display: none;
  }
`

export const SummaryTitle = styled.div`
  height: 22px;
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 22px;
`

export const StepsContainer = styled.div`
  width: 70%;

  @media (max-width: 480px) {
    width: 100%;
  }
`

export const SummaryContainer = styled.div`
  width: 26%;
  padding-left: 20px;
  @media (max-width: 1024px) {
    width: 29%;
  }
  @media (max-width: 480px) {
    width: 100%;
    padding: 0;
    margin-top: 20px;
  }
`

export const FloatingTopMobile = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  flex-flow: column;
  align-items: center;
  background: white;
  width: 100%;
  z-index: 3;
  box-shadow: 1px 2px 4px -1px #8a8a8a;
  padding-top: 12px;
  background: #373737;
  @media (max-width: 698px) {
    display: flex;
  }
`

export const CheckoutTitleMobile = styled.div`
  font-weight: bold;
  background: #4c4c4c;
  color: #c1c1c1;
  padding: 4px 12px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-top: -13px;
  margin-bottom: 8px;
  font-size: 13px;
`

export const StepWrapperMobile = styled.div`
  .ant-steps-item-icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    padding-top: 3px;
  }
  .ant-steps-item-content {
    min-height: 28px !important;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    background: ${BLUE};
  }
  .ant-steps-item-process .ant-steps-item-icon {
    border-color: ${BLUE};
  }
  .ant-steps-item-wait .ant-steps-item-icon {
    border-color: ${BLACK_SHADOW};
    background-color: ${WHITE};
  }
  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: ${BLACK};
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${BLUE};
    background-color: ${WHITE};
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${BLUE};
  }
  .ant-steps-item-finish
    > .ant-steps-item-content
    > .ant-steps-item-title:after {
    background-color: ${BLUE};
  }

  .ant-steps-horizontal.ant-steps-label-horizontal {
    display: flex;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title {
    font-size: 12px;
    line-height: 2;
    color: white;
  }
  .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-icon {
    margin-right: 5px;
  }

`

export const StepWrapper = styled.div`
  .ant-steps-item-process .ant-steps-item-icon {
    background: ${BLUE};
  }
  .ant-steps-item-process .ant-steps-item-icon {
    border-color: ${BLUE};
  }
  .ant-steps-item-wait .ant-steps-item-icon {
    border-color: ${BLACK_SHADOW};
    background-color: ${WHITE};
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${BLUE};
    background-color: ${WHITE};
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${BLUE};
  }
  .ant-steps-item-finish
    > .ant-steps-item-content
    > .ant-steps-item-title:after {
    background-color: ${BLUE};
  }
  @media (max-width: 698px) {
    display: none;
  }
  @media (max-width: 480px) {
    .ant-steps-horizontal.ant-steps-label-horizontal {
      display: flex;
    }
    .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-title {
      font-size: 12px;
    }
    .ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-icon {
      margin-right: 5px;
    }
  }
`

export const ContinueButton = styled(Button)`
  height: 40px;
  width: 138.23px;
  border-radius: 2px;
  background-color: ${BLUE};
  color: ${WHITE};

  &:hover {
    border-color: ${BLUE};
    background-color: ${BLUE};
    color: ${WHITE};
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`

interface StepProps {
  clickable?: boolean
}

export const StepIcon = styled.div`
  background-color: ${({ clickable }: StepProps) =>
    !clickable ? '#4a90e2' : '#fff'};
  color: #fff;
  width: 32px;
  border-radius: 50%;
  font-size: 14px;
  cursor: ${({ clickable }: StepProps) => (clickable ? 'pointer' : 'default')};
  @media (max-width: 698px) {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    padding-top: 6px;
    background-color: unset;
  }
`

export const CheckIcon = styled(Icon)`
  color: #4a90e2;
  font-size: 27px;
  @media (max-width: 698px) {
    font-size: 18px;
  }
`

export const CurrencyWarningText = styled.div`
  font-size: 18px;
  font-weight: bold;
`

export const PlaceOrderLoading = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${BLACK_SHADOW};
  justify-content: center;
  align-items: center;
  z-index: 100;
  animation: fade-in-bottom 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-bottom {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBatch = styled.div`
  display: flex;
  flex-flow: column;
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  align-items: center;
  justify-content: center;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 30px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const StyledSpin = styled(Spin)`
  margin-top: 34px;
  margin-bottom: -28px;
`

export const InfoDescription = styled.div`
  text-align: center;
  font-size: 14px;
`

export const InvoiceAnimation = styled.img`
  max-width: 230px;
  width: 100%;
  object-fit: contain;
`

export const ModalLoading = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  background: white;
  padding: 8px;
  border-radius: 14px;
  box-shadow: 0px 3px 8px -2px ${GRAY_DARK};
  padding-bottom: 18px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const ProcessingDiv = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-family: Avenir-Medium;
  align-items: center;
`

export const SpinStyled = styled(Spin)`
  margin-left: 16px;
`

export const InfoText = styled.div`
  font-family: Avenir;
  margin: 18px 0;
`

export const InfoIconPrint = styled(Icon)`
  position: absolute;
  right: -6px;
  top: -6px;
  background: ${WHITE};
  border-radius: 25px;
  color: ${BLUE};
  font-size: 18px;
  box-shadow: -1px 1px 3px -1px grey;
`

export const InfoTextSecondary = styled.div`
  background: #fffbf4;
  border: 1px solid #ffebc7;
  border-radius: 5px;
  position: relative;
  padding: 0px 14px;
`

export const CheckList = styled.div``

export const CheckLabel = styled.div``

export const CheckGreen = styled(Icon)`
  color: ${GREEN};
  font-size: 16px;
  margin-right: 8px;
`

export const okButtonStyles = {
  background: BLUE,
  border: 'none',
  borderRadius: '3px'
}

export const MaintenanceLayout = styled.div`
  min-height: calc(100vh - 192px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${WHITE};
  flex-flow: column;
  padding: 64px 18px;
`

export const MaintenanceImage = styled.img`
  max-width: 440px;
  width: 100%;
`

export const MaintenaceLink = styled.div`
  margin-top: 38px;
  box-shadow: 0px 2px 5px -3px black;
  border-radius: 53px;
  padding: 8px 14px;
  background: white;
  color: #577395;
  font-weight: bold;
  font-family: Avenir;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const DeliveryDiv = styled.div`
  display: flex;
  position: absolute;
  top: 30px;
  right: 42px;
  animation: fade-in-right 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(12px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media(max-width: 480px) {
    display: none;
  }
`

export const DeliveryDivMobile = styled.div`
  display: none;
  position: absolute;
  top: 30px;
  right: 42px;
  animation: fade-in-right 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(12px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media(max-width: 480px) {
    display: ${({ show }: DivProps) => show ? 'flex' : 'none'};
    position: unset;
    justify-content: center;
    margin-bottom: -8px;
  }
`

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
`

export const InfoIcon = styled(Icon)`
  display: inline-flex;
  margin-top: 5px;
  margin-right: 8px;
  font-size: 12px;
`

export const PopoverText = styled.div`
  font-size: 12px;
  color: ${BLACK};
  font-family: Avenir;
  font-weight: normal;
`

export const DeliveryLabels = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: flex-end;
  margin-right: 16px;
  font-size: 13px;
  @media (max-width: 480px) {
    flex-flow: row;
    align-items: center;
  }
`

export const DeliveryValue = styled.div`
  font-weight: bold;
  font-family: Avenir;
  @media (max-width: 480px) {
    margin-left: 8px;
  }
`

export const PackageIcon = styled.img`
  max-width: 40px;
  @media (max-width: 480px) {
    max-width: 38px;
    margin-top: -8px;
  }
`

export const EditContent = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
`

export const EditContent2 = styled.div`
  margin: 22px 0 28px -38px;
  text-align: left;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
`

export const TitleEditBulkShipping = styled.div`
  display: flex;
  justify-content: space-evenly;
  font-weight: bold;
  font-family: Avenir;
`

export const BulkShipTagIconContainer = styled.div``

export const BulkShipTagIcon = styled.img`
  width: ${({ small }: StyledProps) => small ? '17px' : '30px'};
`

export const RecommendIcon = styled(Icon)`
  margin-right: 12px;
  font-size: 18px;
  vertical-align: bottom;
  margin-bottom: 2px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const PromptTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  font-family: Avenir;
  margin-bottom: 10px;
  color: ${GRAY_DARK};
`

export const InfoTextShipping = styled.div`
  margin-left: -38px;
  margin-bottom: 4px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Checkout/styledComponents.tsx